import React from "react";
import PropTypes from 'prop-types';

import { BFLoader } from '@components/common/loader/main';
import { bulkRefreshSections, pluralizeObject } from '@helpers/show_page_helpers';
import { DangerButton } from '@components/library/button/index';
import renderModal from '../modals/renderModal';


class BulkDeleteModal extends React.Component {
  state = {
    disableSubmitButton: false,
    isLoading: false
  }

  componentWillUnmount() {
    this.props.closeModal();
  }

  deleteAssets = () => {
    this.setState({ disableSubmitButton: true, isLoading: true });

    const { addRemoveSelected, closeModal, selectedAssetKeys } = this.props;

    $.ajax({
      type: "DELETE",
      url: '/api/v4/bulk_actions/assets/destroy?queue_priority=high',
      contentType: "application/json",
      data: JSON.stringify(this.buildDataBody()),
      context: this,
      headers: { Authorization: `Bearer ${BF_Token}` },
      success: (response, _, xhr) => {
        const assetQtyObject = pluralizeObject(selectedAssetKeys);
        const assetCopy = assetQtyObject.plural ? t('Assets') : t('Asset');

        addRemoveSelected([]);
        closeModal();
        if (xhr.status === 202) {
          // processing async because of quantity
          const delayTime = 1000 + (assetQtyObject.qty * 50);
          bulkRefreshSections(selectedAssetKeys, delayTime);
          setTimeout(() => {
            BF.fx.updateAssetPageCount(assetQtyObject.qty, false);
          }, delayTime);
          Notify.create({
            title: `${assetQtyObject.qty} ${assetCopy} ${t('processing')}!`,
            body: t('Assets in deletion progress. Your changes will take place over the next few minutes.'),
            type: 'success'
          });
        } else {
          bulkRefreshSections(selectedAssetKeys, 1000);
          BF.fx.updateAssetPageCount(assetQtyObject.qty, false);
          Notify.create({
            title: `${assetQtyObject.qty} ${assetCopy} ${t('deleted')}!`,
            type: 'success'
          });
        }
      },
      error: () => {
        this.setState({ disableSubmitButton: false, isLoading: false });
        Notify.create({
          title: t('An error occurred when deleting assets. Please try again.'),
          type: 'error'
        });
      }
    });
  }

  buildDataBody() {
    const { selectedAssetKeys } = this.props;
    return { data: { asset_keys: Array.from(selectedAssetKeys) } };
  }

  render() {
    const { selectedAssetKeys } = this.props;
    const assetQtyObject = pluralizeObject(selectedAssetKeys);
    const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');
    const loaderActive = this.state.isLoading ? 'loader-active' : '';

    return (
      <div className="modal-content-wrapper bulk-delete-modal">
        <div className="modal-content-wrapper__header">
          <span className="bff-trash icon" aria-hidden="true" />
          <h3 className="modal-title">{t('Delete')}</h3>
          <button
            className="close-button"
            onClick={this.props.closeModal}
            type="button"
          >
            <span className="bff-close" />
          </button>
        </div>
        <div className={`modal-content-wrapper__body ${loaderActive}`}>
          {this.state.isLoading
            ? <BFLoader />
            : (
              <div>
                <h1 className="body-title">{`${selectedAssetKeys.size} ${assetCopy}`}</h1>
                <h3 className="body-title">
                  {t('Are you sure you want to permanently delete')}
                  <span className="bold-text">
                    {`${selectedAssetKeys.size} ${assetCopy}?`}
                  </span>
                </h3>
                <div className="button-container">
                  <DangerButton
                    className="t-confirm-modal"
                    disabled={this.state.disableSubmitButton}
                    onClick={this.deleteAssets}
                    size="small"
                  >
                    {t('Delete')}
                  </DangerButton>
                </div>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

BulkDeleteModal.propTypes = {
  addRemoveSelected: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

const ModalComponent = renderModal(BulkDeleteModal, 'BulkDeleteModal');
export default ModalComponent;
